import { Button, Tooltip } from '@mui/material';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';

const HoldButton = ({
  countDown,
  countMessage,
  onClick,
  children,
  ...props
}) => {
  const [timeLeft, setTimeLeft] = useState(countDown || 0);
  const [isHolding, setIsHolding] = useState(false);
  const timerRef = useRef(null);

  const hasCountDown = typeof countDown === 'number' && countDown > 0;

  const startTimer = () => {
    if (!hasCountDown) return;

    setIsHolding(true);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          if (timerRef.current) clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (!hasCountDown) return;

    if (timeLeft === 0) {
      onClick();
    }

    if (timerRef.current) clearInterval(timerRef.current);
    setIsHolding(false);
    setTimeLeft(countDown);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const handleClick = (e) => {
    if (!hasCountDown) {
      onClick(e);
    }
  };

  const buttonLabel =
    isHolding && hasCountDown && timeLeft > 0
      ? `${timeLeft}s halten...`
      : isHolding && timeLeft === 0
        ? 'Loslassen!'
        : children;

  return (
    <Tooltip title={countMessage || ''} arrow>
      <span style={{ display: 'inline-block' }}>
        <Button
          {...props}
          onClick={handleClick}
          onMouseDown={startTimer}
          onMouseUp={stopTimer}
          onMouseLeave={stopTimer}
          onTouchStart={startTimer}
          onTouchEnd={stopTimer}
          sx={{
            minWidth: '120px',
            ...props.sx,
          }}
        >
          {buttonLabel}
        </Button>
      </span>
    </Tooltip>
  );
};

export default HoldButton;
